// Teaser card slider
const teaserCardSlider = document.querySelectorAll('[data-slider-parent] [data-slider="teaser-card-slider"]');

const teaserCardSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  watchSlidesProgress: true,
  centerInsufficientSlides: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      spaceBetween: 24,
    },
    1200: {
      spaceBetween: 30,
    },
  },
};

const initTeaserCardSlider = () => {
  teaserCardSlider.forEach((el) => {
    const parentEle = el.closest('[data-slider-parent]');
    const arrowRight = parentEle?.querySelector('.arrow-right');
    const arrowLeft = parentEle?.querySelector('.arrow-left');
    teaserCardSliderOptions.navigation.nextEl = arrowRight;
    teaserCardSliderOptions.navigation.prevEl = arrowLeft;

    if (windowWidth() > 767) {
      new Swiper(el, teaserCardSliderOptions);
    } else {
      enableArrowScrollSync(parentEle);
    }
  });
};

initTeaserCardSlider();

setupResponsiveSliders({
  sliderElements: teaserCardSlider,
  breakpoint: 767,
  initSlider: initTeaserCardSlider,
  mobileFallback: enableArrowScrollSync,
  parentSelector: '[data-slider-parent]',
});
